import { useEffect, useRef, useState } from 'react';

export default function PresetsDropdown({ presets = [], selected, onToggle, onClear }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const sel = selected instanceof Set ? selected : new Set(selected || []);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const label = sel.size === 0 ? 'Presets' : `Presets (${sel.size})`;

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="btn small"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {label} ▾
      </button>
      {open && (
        <div
          role="listbox"
          aria-multiselectable="true"
          className="topbar-menu"
          style={{ left: 0, right: 'auto', minWidth: 220 }}
        >
          {presets.map((p) => {
            const on = sel.has(p.id);
            return (
              <label key={p.id} className="topbar-menu-item" style={{ cursor: 'pointer' }}>
                <input type="checkbox" checked={on} onChange={() => onToggle(p.id)} />
                {p.label}
              </label>
            );
          })}
          {sel.size > 0 && (
            <>
              <div className="topbar-menu-sep" />
              <button type="button" className="topbar-menu-item" onClick={onClear}>
                Clear presets
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
